import { Form, Input, Radio } from "antd";
import { styled } from "styled-components";

export const StyledAntdInput = styled(Input)`
  && {
    outline: 0;
    border-width: 0 0 1px;
    border-color: var(--color-border);
    background-color: transparent;
    color: var(--color-text);
    border-radius: 0;
    padding-left: 0;
    font-size: var(--text-base);
    transition:
      border-color var(--transition-base),
      background-color var(--transition-base);

    &::placeholder,
    & input::placeholder {
      color: var(--color-text-subtle);
      opacity: 1;
    }

    &:focus {
      background-color: transparent;
      border-color: var(--color-primary);
      border-width: 0 0 2px;
      outline: 0;
      box-shadow: none;
    }

    &:hover {
      border-color: var(--color-border-strong);
    }
  }
`;

export const StyledFormItem = styled(Form.Item)`
  .ant-form-item-label > label {
    font-size: var(--text-sm);
    color: var(--color-text-muted);
    font-weight: var(--weight-medium);
  }

  .ant-form-item-explain,
  .ant-form-item-split {
    font-size: var(--text-xs);
  }
`;

export const StyledRadio = styled(Radio)`
  .ant-radio {
    display: none;
  }
`;
